import {CustomFieldTO, StTagTO} from 'generated/JavaTO'
import {CFAttrKey} from 'module/CustomField/constant/CFAttrConstants'
import {CF} from 'module/CustomField/util/CustomField'
import {StTagStateType} from 'module/StTag/reducer/StTagReducer'
import {selStTagById} from 'module/StTag/selector/StTagSelector'
import {StateObservable} from 'redux-observable'
import {selBSCollectionByIdDict} from 'module/BSCollection/selector/BSCollectionSelector'
import {SisName} from 'util/SisName'
import {BSCollectionByID} from 'module/BSCollection/type/BSCollectionStateType'
import {StTagZu} from 'generated/JavaTOmodifications'
import {FieldError} from 'module/CustomField/type/FieldError'
import {getCFRoundModelParametersForStTag, getCFRoundResult, resolveCFRoundParameters, RoundStTagPrefix} from 'module/CustomField/util/CFAttrRoundUtil'
import {CFMember} from 'module/CustomField/type/CFType'

const selStTagZuById = selBSCollectionByIdDict[SisName.StTagZu]

export function validateByCFAttrs(cfDefs: CustomFieldTO[], model: any, state$: StateObservable<any>): FieldError[] {
	let stTagById: StTagStateType['StTag']['byId'] | null = null
	let stTagZuById: BSCollectionByID<StTagZu> | null = null
	cfDefs = cfDefs.filter(cfDef => !CF.isLabelField(cfDef))
	return cfDefs.flatMap(cfDef => cfDef.cfAttrs.flatMap((cfAttr): FieldError[] => {
		if (cfAttr.key === CFAttrKey.roundTime || cfAttr.key === CFAttrKey.roundDuration) {
			// validate that value is rounded correctly and all dependecies are loaded
			const exceptions = cfDef.cfAttrs.filter(ca => ca.key === CFAttrKey.roundException).map(x => x.value)
			let stTag: StTagTO | undefined;
			if ([cfAttr.value, cfAttr.type, ...exceptions].some(x => x?.startsWith(RoundStTagPrefix))) {
				if (!stTagById) stTagById = selStTagById(state$.value) || {}
				if (!stTagZuById) stTagZuById = selStTagZuById(state$.value) || {}
				const {persNr, date} = getCFRoundModelParametersForStTag(model)
				const stTagZu = stTagZuById[persNr + '_' + date]
				stTag = stTagById[stTagZu?.stTagKey]
				if (!stTag) return [{
					field: cfDef.id,
					message: "Parametrierte Rundungsdaten sind noch nicht verfügbar. Bitte prüfen Sie die Parametrierung oder ändern sie den Wert nochmals.",
				}]
			}
			let v = CF.getValueFrom(cfDef, model)
			const members = Array.isArray(v) ? v : [v]
			return members.flatMap(member => {
				let pos: number | undefined
				let value: number | null
				if (CF.isCFNamespace(cfDef)) {
					pos = (member as CFMember).pos
					value = (member as CFMember).data as number
				} else {
					pos = undefined
					value = member as number
				}
				if ((value % 100) && cfDef.dstField === 'bookingTime') {
					// ignore booking seconds for validation (test case: multiple saved bookings at the same timestamp, booking with seconds > 0 edited)
					value = value - (value % 100)
				}
				const rounded = getCFRoundResult({
					allCFDefs: cfDefs,
					cfDef,
					cfAttr,
					model,
					value: value,
					pos,
					...resolveCFRoundParameters(cfAttr, exceptions, stTag),
				})
				if (rounded !== value) {
					return [{
						field: cfDef.id,
						pos,
						message: "Der Wert ist nicht korrekt gerundet",
					}]
				}
				return []
			})
		}
		return []
	}))
}